export const gridSize = 10;
